<template>
  <div class="flex gap-y-1" v-show="isShow">
    <div :class="direction" class="w-full flex gap-x-4 gap-y-1 text-brand-black-secondary">
      <label
        v-if="label"
        :for="fieldName"
        :class="labelClass"
        class="relative flex items-center gap-x-2 text-brand-black-secondary font-bold"
      >
        <div>
          <span> {{ t9nLabel }}</span>
        </div>
        <HintTippy v-if="hint" :hint="hint"></HintTippy>
      </label>
      <div class="w-full relative flex justify-start items-center">
        {{ displayValue }}
      </div>
    </div>
  </div>
</template>

<script setup>
import useVisible from '@/composables/useVisible'
import { useFormStore } from '@/stores/form'
import lodashGet from 'lodash/get'
import { DateTime } from 'luxon'
import { computed, toRef, useAttrs } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'

const attrs = useAttrs()

const props = defineProps({
  hint: String,
  labelValue: String,
  date_format: String,
  fieldName: {
    type: String,
    required: true
  },
  label: {
    type: String,
    required: true
  },
  modelValue: {
    type: [String, Number]
  },
  rules: Array,
  showRules: Object,
  defaultValue: String,
  direction: {
    type: String,
    default: 'flex-row md:items-start'
  },
  labelClass: {
    type: String,
    default: () => 'w-full md:w-1/3'
  },
  dependentOn: String,
  debounceTime: {
    type: Number,
    default: () => 0
  }
})

const formStore = useFormStore()
const fieldName = toRef(props, 'fieldName')
const i18n = useI18n()
const { findShowRule, getBindObj } = useVisible()
const route = useRoute()

const isShow = computed(() => {
  if (props.showRules) {
    return findShowRule(
      props.showRules.any || props.showRules.all,
      props.showRules.any ? 'any' : 'all',
      getBindObj(route.params.serviceId)
    )
  } else {
    return true
  }
})
const t9nLabel = computed(() => i18n.t(props.label))
// access properties by path
const displayValue = computed(() => {
  let value = props.defaultValue || lodashGet(formStore.form.values, fieldName.value)
  if (props.date_format) {
    value = DateTime.fromISO(value).toFormat(props.date_format)
  }

  if (attrs?.is_t9nKey) {
    return i18n.t(value)
  }

  if (attrs?.is_emailmask) {
    const [emailName,emailDomain] = value.split('@');
    return `${emailName.split('').fill('*',1).join('')}@${emailDomain}`;
  }

  return value
})
</script>

<style lang="scss" scoped></style>
